// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-assistant.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  border: none;
}

.legal-assistant.drag-over {
  outline: 2px dashed #667eea;
  outline-offset: -2px;
  background-color: rgba(102, 126, 234, 0.05);
}

.legal-assistant.drag-over .chat-messages {
  background-color: rgba(102, 126, 234, 0.1);
}

/* Embedded Header - Simplified for dashboard integration */
.embedded-header {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f3f4 !important;
  padding: 16px 32px !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  position: relative !important;
  z-index: 10 !important;
  border-radius: 16px 16px 0 0 !important;
}

.embedded-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  text-align: center;
}

/* Top Bar - Matching Dashboard structure */
.top-bar {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(249, 250, 251, 0.9) 100%
  ) !important;
  border-bottom: 1px solid rgba(229, 231, 235, 0.3) !important;
  padding: 12px 20px !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  position: relative !important;
  z-index: 10 !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px 16px 0 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

.top-bar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.logo {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #000000;
}

.assistant-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}

.dock-toggle-btn {
  background: #111827;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  backdrop-filter: blur(10px);
}

.dock-toggle-btn:hover {
  background-color: #1f2937;
}

.top-bar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-profile {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s;
  color: #000000;
}

.user-profile:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.user-avatar {
  font-size: 16px;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}

.dropdown-arrow {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  transition: transform 0.2s;
}

.user-profile:hover .dropdown-arrow {
  transform: rotate(180deg);
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 0;
  min-width: 120px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.2s;
}

.user-profile:hover .user-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.user-dropdown button {
  width: 100%;
  padding: 8px 16px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.2s;
}

.user-dropdown button:hover {
  background-color: #f5f5f5;
}

.clear-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.3);
  backdrop-filter: blur(10px);
}

.clear-btn:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
}

.assistant-header {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(249, 250, 251, 0.9) 100%
  );
  color: #000000;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(229, 231, 235, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 10;
  backdrop-filter: blur(20px);
  border-radius: 16px 16px 0 0;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-to-dashboard-btn {
  background: rgba(255, 255, 255, 0.2);
  color: #000000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  gap: 6px;
}

.back-to-dashboard-btn:hover {
  background-color: #e5e7eb;
  color: #374151;
}

.assistant-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.2px;
  color: #000000;
}

.fullscreen-toggle {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #6b7280;
  font-size: 20px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s;
  backdrop-filter: blur(10px);
}

.fullscreen-toggle:hover {
  background-color: #e5e7eb;
  color: #374151;
}

.chat-messages {
  flex: 1 1 !important;
  overflow-y: auto !important;
  padding: 20px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
  min-height: 0 !important;
  max-height: calc(100vh - 200px) !important;
}

.chat-messages.drag-over {
  background-color: rgba(102, 126, 234, 0.05);
}

.chat-input-container {
  flex-shrink: 0 !important;
  min-height: 80px !important;
}

.message {
  display: flex;
  flex-direction: column;
  max-width: 85%;
  animation: messageSlideIn 0.3s ease-out;
}

@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Typing animation for assistant messages */
.message.assistant .message-text.typing {
  position: relative;
}

.message.assistant .message-text.typing::after {
  content: "|";
  color: #667eea;
  animation: blink-cursor 1s infinite;
  margin-left: 1px;
  font-weight: normal;
}

@keyframes blink-cursor {
  0%,
  50% {
    opacity: 1;
  }
  51%,
  100% {
    opacity: 0;
  }
}

.message.user {
  align-self: flex-end;
}

.message.assistant {
  align-self: flex-start;
}

.message-content {
  padding: 14px 18px;
  border-radius: 12px;
  position: relative;
  word-wrap: break-word;
  min-height: 20px;
}

/* Stable message container during streaming */
.message.assistant .message-content.streaming {
  min-height: fit-content;
  height: auto;
}

.message.user .message-content {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  margin-left: auto;
  border-radius: 18px 18px 4px 18px;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
  backdrop-filter: blur(10px);
}

.message.assistant .message-content {
  background: rgba(255, 255, 255, 0.9);
  color: #374151;
  border-radius: 18px 18px 18px 4px;
  border: 1px solid rgba(229, 231, 235, 0.3);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(15px);
}

.message-text {
  white-space: pre-wrap;
  line-height: 1.6;
  font-size: 15px;
  transition: none; /* Disable transitions during streaming */
}

/* Stable height during streaming */
.message.assistant .message-text.typing {
  overflow-wrap: break-word;
  word-break: break-word;
}

.message-timestamp {
  font-size: 12px;
  color: #999;
  margin-top: 6px;
  text-align: right;
  font-weight: 500;
}

.message.user .message-timestamp {
  text-align: right;
}

.message.assistant .message-timestamp {
  text-align: left;
}

.file-attachments {
  margin-bottom: 8px;
}

.file-attachment {
  background: rgba(255, 255, 255, 0.9);
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.loading-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-style: italic;
}

.loading-indicator::after {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #ddd;
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.chat-input-form {
  display: flex !important;
  flex-direction: column !important; /* Stack: buttons row above, input row below */
  align-items: stretch !important;
  gap: 6px !important;
  position: relative;
  width: 100%;
  min-height: 60px;
}

.input-actions {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 8px !important;
  flex-shrink: 0 !important;
  justify-content: flex-start !important;
  order: 0 !important; /* Explicitly ensure it's on top */
}

.chat-input-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  order: 1; /* Ensure appears below buttons row */
}

.file-upload-btn {
  background: linear-gradient(
    135deg,
    rgba(139, 92, 246, 0.1) 0%,
    rgba(59, 130, 246, 0.1) 50%,
    rgba(147, 51, 234, 0.1) 100%
  );
  color: #6b7280;
  border: 2px solid rgba(229, 231, 235, 0.4);
  border-radius: 12px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 44px;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.file-upload-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(139, 92, 246, 0.1) 0%,
    rgba(59, 130, 246, 0.1) 50%,
    rgba(147, 51, 234, 0.1) 100%
  );
  border-color: hsl(253, 64%, 58%);
  color: #10b981;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.research-mode-btn {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.1) 0%,
    rgba(59, 130, 246, 0.1) 50%,
    rgba(147, 51, 234, 0.1) 100%
  );
  color: #6b7280;
  border: 2px solid rgba(229, 231, 235, 0.4);
  border-radius: 12px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 44px;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.research-mode-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.15) 0%,
    rgba(59, 130, 246, 0.15) 50%,
    rgba(147, 51, 234, 0.15) 100%
  );
  border-color: #667eea;
  color: #667eea;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

/* Active state simplified: only border emphasis, no darker fill */
.research-mode-btn.active {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.1) 0%,
    rgba(59, 130, 246, 0.1) 50%,
    rgba(147, 51, 234, 0.1) 100%
  ); /* Same as base */
  border-color: #667eea;
  color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15),
    0 2px 10px rgba(102, 126, 234, 0.18);
}

.research-mode-btn.active:hover {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.25) 0%,
    rgba(59, 130, 246, 0.25) 50%,
    rgba(147, 51, 234, 0.25) 100%
  );
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.chat-input {
  flex: 1 1 auto !important;
  width: auto !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 15px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  resize: none;
  outline: none;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  color: #000000;
  min-height: 16px;
  max-height: 160px;
  overflow-y: auto;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
}

.chat-input:focus {
  border-color: hsl(253, 64%, 58%);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1), 0 4px 12px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

.chat-input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
  opacity: 0.5;
}

.chat-input::placeholder {
  color: #999;
  font-style: italic;
}

.send-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 10px 12px !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 44px !important;
  height: 44px !important;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3) !important;
  backdrop-filter: blur(10px) !important;
}

.send-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
  color: white !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.send-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed;
  transform: none;
  background: linear-gradient(135deg, #d1d5db 0%, #9ca3af 100%) !important;
  color: white !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Ensure React icons are visible and properly styled */
.send-btn svg,
.file-upload-btn svg {
  width: 16px;
  height: 16px;
  display: block;
}

.send-btn svg {
  color: white !important;
  fill: currentColor;
}

.file-upload-btn svg {
  color: #667eea !important;
  fill: currentColor;
}

.send-btn:hover:not(:disabled) svg {
  color: white !important;
}

.file-upload-btn:hover svg {
  color: #5a67d8 !important;
}

/* Loading icon animation */
.loading-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.drag-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(102, 126, 234, 0.1);
  border: 2px dashed #667eea;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.drag-message {
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #667eea;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Responsive design */
@media (max-width: 768px) {
  .legal-assistant {
    border-left: none;
  }

  .message {
    max-width: 95%;
  }

  .chat-input-form {
    gap: 4px;
  }

  .chat-input {
    font-size: 16px; /* Prevent zoom on iOS */
  }
}

/* Download section styles */
.download-section {
  margin-top: 12px;
  padding: 12px;
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f4fd 100%);
  border-radius: 12px;
  border: 1px solid #e1e8ff;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.download-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  text-decoration: none;
  justify-content: center;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
}

.download-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
}

.download-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
}

/* ================= Professional Assistant Formatting ================= */
.assistant-formatted {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen;
  font-size: 15px;
  line-height: 1.55;
  display: flex;
  flex-direction: column;
  gap: 4px;
  white-space: normal;
}

.assistant-formatted .assistant-heading {
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #374151;
  background: linear-gradient(90deg, #eef2ff 0%, #f0fdfa 100%);
  padding: 4px 8px;
  border-radius: 6px;
  margin-right: 6px;
  border: 1px solid #e5e7eb;
}

.assistant-list {
  margin: 2px 0 6px 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.assistant-list.ordered {
  list-style: decimal;
}
.assistant-list {
  list-style: disc;
}
.assistant-list li {
  padding-left: 4px;
  line-height: 1.5;
}

.assistant-paragraph {
  margin: 0;
  position: relative;
}

.assistant-spacer {
  height: 8px;
}

.assistant-link {
  color: #2563eb;
  text-decoration: none;
  font-weight: 500;
}
.assistant-link:hover {
  text-decoration: underline;
}

.inline-code {
  background: #f3f4f6;
  padding: 2px 5px;
  border-radius: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", monospace;
  font-size: 13px;
  border: 1px solid #e5e7eb;
}

.kv-pair strong {
  color: #111827;
}
.kv-pair {
  display: inline-block;
  margin-right: 10px;
}

/* Risk / status tags */
.risk-tag::before {
  content: attr(data-label);
}
.risk-tag.critical {
  background: linear-gradient(90deg, #fee2e2, #fecaca);
  border-left: 4px solid #dc2626;
  padding: 6px 10px;
  border-radius: 6px;
}
.risk-tag.warning {
  background: linear-gradient(90deg, #fef9c3, #fde68a);
  border-left: 4px solid #d97706;
  padding: 6px 10px;
  border-radius: 6px;
}
.risk-tag.success {
  background: linear-gradient(90deg, #dcfce7, #bbf7d0);
  border-left: 4px solid #059669;
  padding: 6px 10px;
  border-radius: 6px;
}

.risk-tag.critical strong {
  color: #991b1b;
}
.risk-tag.warning strong {
  color: #92400e;
}
.risk-tag.success strong {
  color: #065f46;
}

/* Improve spacing after formatted block inside message bubble */
.message.assistant .assistant-formatted {
  width: 100%;
}

/* Markdown style headings inside assistant messages */
.assistant-formatted .assistant-md-heading {
  font-weight: 600;
  line-height: 1.3;
  margin: 10px 0 4px 0;
  color: #111827;
  position: relative;
}
.assistant-formatted .assistant-md-heading.h1 {
  font-size: 18px;
  padding-top: 4px;
}
.assistant-formatted .assistant-md-heading.h2 {
  font-size: 16px;
}
.assistant-formatted .assistant-md-heading.h3 {
  font-size: 15px;
}
.assistant-formatted .assistant-md-heading:not(:first-child)::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 0;
  height: 1px;
  width: 60%;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0));
}

/* Section wrapper */
.assistant-section {
  margin: 8px 0 10px 0;
}
.assistant-heading-line {
  margin-bottom: 6px;
}

/* Pill list styling (risk signals, requirements) */
.pill-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.pill {
  font-size: 12px;
  line-height: 1.2;
  padding: 6px 10px;
  border-radius: 999px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #374151;
  font-weight: 500;
  letter-spacing: 0.25px;
  max-width: 320px;
  white-space: normal;
}
.pill.info {
  background: #f1f5f9;
  border-color: #e2e8f0;
}
.pill.warning {
  background: #fef9c3;
  border-color: #fcd34d;
  color: #92400e;
}
.pill.critical {
  background: #fee2e2;
  border-color: #fca5a5;
  color: #991b1b;
}

/* Improve paragraph spacing after pills */
.assistant-section + .assistant-paragraph {
  margin-top: 6px;
}

/* Clear Chat Confirmation Dialog */
.assistant-body {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  margin: 0;
  padding: 0;
  height: calc(100vh - 65px);
  overflow: hidden;
}

.confirmation-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
  border-radius: 0 0 16px 16px;
  margin-top: 0;
}

.confirmation-dialog {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.confirmation-content {
  padding: 24px;
}

.confirmation-content h3 {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.confirmation-content p {
  margin: 0 0 20px 0;
  color: #666;
  line-height: 1.5;
  text-align: center;
}

.confirmation-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.confirm-btn,
.cancel-btn {
  padding: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  width: 120px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-grow: 0;
  min-width: 120px;
  max-width: 120px;
}

.confirm-btn {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
}

.cancel-btn {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
}

.cancel-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.4);
  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);
}

/* Responsive confirmation dialog */
@media (max-width: 480px) {
  .confirmation-dialog {
    width: 95%;
    margin: 20px;
  }

  .confirmation-content {
    padding: 20px;
  }

  .confirmation-buttons {
    flex-direction: column;
  }

  .confirm-btn,
  .cancel-btn {
    width: 100%;
    min-width: unset;
    max-width: unset;
  }
}

.legal-assistant {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: transparent;
  border-left: none;
  position: relative;
  box-shadow: none;
  min-width: 250px;
  max-width: 800px;
}

.resizer-handle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: ew-resize;
  background: transparent;
}
.resizer-handle:hover {
  background: rgba(0, 0, 0, 0.1);
}

/* ================= Enhanced AI Research Mode Button ================= */
/* Extends base .research-mode-btn styling without breaking existing layout */
.research-mode-btn.ai-mode-btn {
  position: relative;
  overflow: hidden;
  font-weight: 700;
  letter-spacing: 0.5px;
  font-size: 13px;
  border: 2px solid rgba(0, 0, 0, 0.08); /* Neutral border when inactive */
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.55) 0%,
    rgba(240, 242, 255, 0.5) 55%,
    rgba(230, 235, 255, 0.55) 100%
  );
  color: #374151;
  transition: transform 0.3s ease, border-color 0.3s ease;
  backdrop-filter: blur(14px);
  isolation: isolate;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.research-mode-btn.ai-mode-btn .ai-text {
  color: #4f46e5; /* Plain indigo text when inactive */
  text-shadow: none;
  position: relative;
  z-index: 2;
  letter-spacing: 0.5px;
}

.research-mode-btn.ai-mode-btn .ai-sparkles {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* Sparkle pseudo elements */
.research-mode-btn.ai-mode-btn .ai-sparkles::before,
.research-mode-btn.ai-mode-btn .ai-sparkles::after {
  content: "✦";
  position: absolute;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 0 6px rgba(255, 255, 255, 0.8),
    0 0 14px rgba(99, 102, 241, 0.9);
  opacity: 0;
  transform: scale(0.4) translateY(4px);
  animation: aiSparkle 3.2s linear infinite;
  pointer-events: none;
}

.research-mode-btn.ai-mode-btn .ai-sparkles::before {
  top: 6px;
  left: 6px;
  animation-delay: 0.4s;
}

.research-mode-btn.ai-mode-btn .ai-sparkles::after {
  bottom: 6px;
  right: 8px;
  animation-delay: 1.2s;
  font-size: 8px;
}

/* Hover motion & glow */
.research-mode-btn.ai-mode-btn:hover {
  transform: translateY(-2px);
  border-color: #4f46e5;
}

.research-mode-btn.ai-mode-btn:hover .ai-text {
  text-shadow: 0 0 6px rgba(125, 211, 252, 0.9),
    0 0 16px rgba(147, 51, 234, 0.55);
}

.research-mode-btn.ai-mode-btn.active {
  border-color: #4f46e5; /* Only border indicates active */
  box-shadow: none; /* Remove glow per request */
}

.research-mode-btn.ai-mode-btn.active .ai-text {
  color: #4f46e5;
  background: none;
  text-shadow: none;
}

.research-mode-btn.ai-mode-btn.active .ai-text {
  background: linear-gradient(90deg, #f0f9ff, #e0e7ff, #ddd6fe);
  -webkit-background-clip: text;
  background-clip: text;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.85),
    0 0 22px rgba(96, 165, 250, 0.8);
}

.research-mode-btn.ai-mode-btn.active .ai-sparkles::before,
.research-mode-btn.ai-mode-btn.active .ai-sparkles::after {
  opacity: 1;
}

/* Focus accessibility */
.research-mode-btn.ai-mode-btn:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: 3px;
}

/* Keyframes for sparkle animation */
@keyframes aiSparkle {
  0%,
  65% {
    opacity: 0;
    transform: scale(0.3) translateY(4px) rotate(0deg);
    filter: blur(1px);
  }
  70% {
    opacity: 1;
    transform: scale(1) translateY(0) rotate(20deg);
    filter: blur(0);
  }
  78% {
    opacity: 0.9;
    transform: scale(0.85) translateY(-2px) rotate(45deg);
  }
  90% {
    opacity: 0;
    transform: scale(0.2) translateY(-6px) rotate(70deg);
    filter: blur(2px);
  }
  100% {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LegalAssistant.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,2DAA2D;AAC3D;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,6BAA6B;EAC7B,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE;;;;cAIY;EACZ,4DAA4D;EAC5D,6BAA6B;EAC7B,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,sCAAsC;EACtC,uCAAuC;EACvC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE;;;;GAIC;EACD,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iCAAiC;EACjC,0CAA0C;EAC1C,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wBAAwB;EACxB,iCAAiC,EAAE,8CAA8C;EACjF,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,QAAQ,EAAE,qCAAqC;AACjD;;AAEA;EACE;;;;;GAKC;EACD,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;;;;;GAKC;EACD,gCAAgC;EAChC,cAAc;EACd,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE;;;;;GAKC;EACD,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;;;;;GAKC;EACD,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,kEAAkE;AAClE;EACE;;;;;GAKC,EAAE,iBAAiB;EACpB,qBAAqB;EACrB,cAAc;EACd;wCACsC;AACxC;;AAEA;EACE;;;;;GAKC;EACD,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf;;cAEY;EACZ,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,6EAA6E;EAC7E,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,4DAA4D;EAC5D,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,uBAAuB;EACvB,yDAAyD;EACzD,sCAAsC;AACxC;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,wEAAwE;EACxE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA,uDAAuD;AACvD;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe,EAAE,wBAAwB;EAC3C;AACF;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,6DAA6D;AAC/D;;AAEA,0EAA0E;AAC1E;EACE;UACQ;EACR,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,4DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;gCAC8B;EAC9B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;EACpD,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oDAAoD;EACpD,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oDAAoD;EACpD,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;EACV,yEAAyE;AAC3E;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;;AAEA,yEAAyE;AACzE,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,qCAAqC,EAAE,iCAAiC;EACxE;;;;;GAKC;EACD,cAAc;EACd,uDAAuD;EACvD,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc,EAAE,oCAAoC;EACpD,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA,4BAA4B;AAC5B;;EAEE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B;oCACkC;EAClC,UAAU;EACV,qCAAqC;EACrC,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE;qCACmC;AACrC;;AAEA;EACE,qBAAqB,EAAE,iCAAiC;EACxD,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB;oCACkC;AACpC;;AAEA;;EAEE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE;;IAEE,UAAU;IACV,kDAAkD;IAClD,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,+CAA+C;IAC/C,eAAe;EACjB;EACA;IACE,YAAY;IACZ,qDAAqD;EACvD;EACA;IACE,UAAU;IACV,oDAAoD;IACpD,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".legal-assistant.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  border: none;\n}\n\n.legal-assistant.drag-over {\n  outline: 2px dashed #667eea;\n  outline-offset: -2px;\n  background-color: rgba(102, 126, 234, 0.05);\n}\n\n.legal-assistant.drag-over .chat-messages {\n  background-color: rgba(102, 126, 234, 0.1);\n}\n\n/* Embedded Header - Simplified for dashboard integration */\n.embedded-header {\n  background: #ffffff !important;\n  border-bottom: 1px solid #f1f3f4 !important;\n  padding: 16px 32px !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  position: relative !important;\n  z-index: 10 !important;\n  border-radius: 16px 16px 0 0 !important;\n}\n\n.embedded-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #000000;\n  text-align: center;\n}\n\n/* Top Bar - Matching Dashboard structure */\n.top-bar {\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.95) 0%,\n    rgba(249, 250, 251, 0.9) 100%\n  ) !important;\n  border-bottom: 1px solid rgba(229, 231, 235, 0.3) !important;\n  padding: 12px 20px !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  position: relative !important;\n  z-index: 10 !important;\n  backdrop-filter: blur(20px) !important;\n  border-radius: 16px 16px 0 0 !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;\n}\n\n.top-bar-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.logo {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #000000;\n}\n\n.assistant-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #000000;\n}\n\n.dock-toggle-btn {\n  background: #111827;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  backdrop-filter: blur(10px);\n}\n\n.dock-toggle-btn:hover {\n  background-color: #1f2937;\n}\n\n.top-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.user-profile {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 6px;\n  transition: background-color 0.2s;\n  color: #000000;\n}\n\n.user-profile:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.user-avatar {\n  font-size: 16px;\n}\n\n.user-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #000000;\n}\n\n.dropdown-arrow {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.8);\n  transition: transform 0.2s;\n}\n\n.user-profile:hover .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n.user-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 8px 0;\n  min-width: 120px;\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.2s;\n}\n\n.user-profile:hover .user-dropdown {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.user-dropdown button {\n  width: 100%;\n  padding: 8px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  transition: background-color 0.2s;\n}\n\n.user-dropdown button:hover {\n  background-color: #f5f5f5;\n}\n\n.clear-btn {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.3);\n  backdrop-filter: blur(10px);\n}\n\n.clear-btn:hover {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);\n}\n\n.assistant-header {\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.95) 0%,\n    rgba(249, 250, 251, 0.9) 100%\n  );\n  color: #000000;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(229, 231, 235, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  position: relative;\n  z-index: 10;\n  backdrop-filter: blur(20px);\n  border-radius: 16px 16px 0 0;\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.back-to-dashboard-btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: #000000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.back-to-dashboard-btn:hover {\n  background-color: #e5e7eb;\n  color: #374151;\n}\n\n.assistant-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n  color: #000000;\n}\n\n.fullscreen-toggle {\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  color: #6b7280;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 6px;\n  transition: all 0.2s;\n  backdrop-filter: blur(10px);\n}\n\n.fullscreen-toggle:hover {\n  background-color: #e5e7eb;\n  color: #374151;\n}\n\n.chat-messages {\n  flex: 1 !important;\n  overflow-y: auto !important;\n  padding: 20px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n  min-height: 0 !important;\n  max-height: calc(100vh - 200px) !important;\n}\n\n.chat-messages.drag-over {\n  background-color: rgba(102, 126, 234, 0.05);\n}\n\n.chat-input-container {\n  flex-shrink: 0 !important;\n  min-height: 80px !important;\n}\n\n.message {\n  display: flex;\n  flex-direction: column;\n  max-width: 85%;\n  animation: messageSlideIn 0.3s ease-out;\n}\n\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Typing animation for assistant messages */\n.message.assistant .message-text.typing {\n  position: relative;\n}\n\n.message.assistant .message-text.typing::after {\n  content: \"|\";\n  color: #667eea;\n  animation: blink-cursor 1s infinite;\n  margin-left: 1px;\n  font-weight: normal;\n}\n\n@keyframes blink-cursor {\n  0%,\n  50% {\n    opacity: 1;\n  }\n  51%,\n  100% {\n    opacity: 0;\n  }\n}\n\n.message.user {\n  align-self: flex-end;\n}\n\n.message.assistant {\n  align-self: flex-start;\n}\n\n.message-content {\n  padding: 14px 18px;\n  border-radius: 12px;\n  position: relative;\n  word-wrap: break-word;\n  min-height: 20px;\n}\n\n/* Stable message container during streaming */\n.message.assistant .message-content.streaming {\n  min-height: fit-content;\n  height: auto;\n}\n\n.message.user .message-content {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  margin-left: auto;\n  border-radius: 18px 18px 4px 18px;\n  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);\n  backdrop-filter: blur(10px);\n}\n\n.message.assistant .message-content {\n  background: rgba(255, 255, 255, 0.9);\n  color: #374151;\n  border-radius: 18px 18px 18px 4px;\n  border: 1px solid rgba(229, 231, 235, 0.3);\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  backdrop-filter: blur(15px);\n}\n\n.message-text {\n  white-space: pre-wrap;\n  line-height: 1.6;\n  font-size: 15px;\n  transition: none; /* Disable transitions during streaming */\n}\n\n/* Stable height during streaming */\n.message.assistant .message-text.typing {\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.message-timestamp {\n  font-size: 12px;\n  color: #999;\n  margin-top: 6px;\n  text-align: right;\n  font-weight: 500;\n}\n\n.message.user .message-timestamp {\n  text-align: right;\n}\n\n.message.assistant .message-timestamp {\n  text-align: left;\n}\n\n.file-attachments {\n  margin-bottom: 8px;\n}\n\n.file-attachment {\n  background: rgba(255, 255, 255, 0.9);\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  margin-bottom: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.loading-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #666;\n  font-style: italic;\n}\n\n.loading-indicator::after {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ddd;\n  border-top: 2px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.chat-input-form {\n  display: flex !important;\n  flex-direction: column !important; /* Stack: buttons row above, input row below */\n  align-items: stretch !important;\n  gap: 6px !important;\n  position: relative;\n  width: 100%;\n  min-height: 60px;\n}\n\n.input-actions {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  gap: 8px !important;\n  flex-shrink: 0 !important;\n  justify-content: flex-start !important;\n  order: 0 !important; /* Explicitly ensure it's on top */\n}\n\n.chat-input-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  order: 1; /* Ensure appears below buttons row */\n}\n\n.file-upload-btn {\n  background: linear-gradient(\n    135deg,\n    rgba(139, 92, 246, 0.1) 0%,\n    rgba(59, 130, 246, 0.1) 50%,\n    rgba(147, 51, 234, 0.1) 100%\n  );\n  color: #6b7280;\n  border: 2px solid rgba(229, 231, 235, 0.4);\n  border-radius: 12px;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 44px;\n  height: 44px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.file-upload-btn:hover {\n  background: linear-gradient(\n    135deg,\n    rgba(139, 92, 246, 0.1) 0%,\n    rgba(59, 130, 246, 0.1) 50%,\n    rgba(147, 51, 234, 0.1) 100%\n  );\n  border-color: hsl(253, 64%, 58%);\n  color: #10b981;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.research-mode-btn {\n  background: linear-gradient(\n    135deg,\n    rgba(102, 126, 234, 0.1) 0%,\n    rgba(59, 130, 246, 0.1) 50%,\n    rgba(147, 51, 234, 0.1) 100%\n  );\n  color: #6b7280;\n  border: 2px solid rgba(229, 231, 235, 0.4);\n  border-radius: 12px;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 44px;\n  height: 44px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.research-mode-btn:hover {\n  background: linear-gradient(\n    135deg,\n    rgba(102, 126, 234, 0.15) 0%,\n    rgba(59, 130, 246, 0.15) 50%,\n    rgba(147, 51, 234, 0.15) 100%\n  );\n  border-color: #667eea;\n  color: #667eea;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n}\n\n/* Active state simplified: only border emphasis, no darker fill */\n.research-mode-btn.active {\n  background: linear-gradient(\n    135deg,\n    rgba(102, 126, 234, 0.1) 0%,\n    rgba(59, 130, 246, 0.1) 50%,\n    rgba(147, 51, 234, 0.1) 100%\n  ); /* Same as base */\n  border-color: #667eea;\n  color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15),\n    0 2px 10px rgba(102, 126, 234, 0.18);\n}\n\n.research-mode-btn.active:hover {\n  background: linear-gradient(\n    135deg,\n    rgba(102, 126, 234, 0.25) 0%,\n    rgba(59, 130, 246, 0.25) 50%,\n    rgba(147, 51, 234, 0.25) 100%\n  );\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.chat-input {\n  flex: 1 1 auto !important;\n  width: auto !important;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 15px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  resize: none;\n  outline: none;\n  background: rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n  color: #000000;\n  min-height: 16px;\n  max-height: 160px;\n  overflow-y: auto;\n  line-height: 1.4;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  backdrop-filter: blur(10px);\n}\n\n.chat-input:focus {\n  border-color: hsl(253, 64%, 58%);\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1), 0 4px 12px rgba(0, 0, 0, 0.08);\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-1px);\n}\n\n.chat-input:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.chat-input::placeholder {\n  color: #999;\n  font-style: italic;\n}\n\n.send-btn {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 12px !important;\n  padding: 10px 12px !important;\n  cursor: pointer !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  min-width: 44px !important;\n  height: 44px !important;\n  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3) !important;\n  backdrop-filter: blur(10px) !important;\n}\n\n.send-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;\n  color: white !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;\n}\n\n.send-btn:disabled {\n  opacity: 0.5 !important;\n  cursor: not-allowed;\n  transform: none;\n  background: linear-gradient(135deg, #d1d5db 0%, #9ca3af 100%) !important;\n  color: white !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Ensure React icons are visible and properly styled */\n.send-btn svg,\n.file-upload-btn svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n.send-btn svg {\n  color: white !important;\n  fill: currentColor;\n}\n\n.file-upload-btn svg {\n  color: #667eea !important;\n  fill: currentColor;\n}\n\n.send-btn:hover:not(:disabled) svg {\n  color: white !important;\n}\n\n.file-upload-btn:hover svg {\n  color: #5a67d8 !important;\n}\n\n/* Loading icon animation */\n.loading-icon {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.drag-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(102, 126, 234, 0.1);\n  border: 2px dashed #667eea;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.drag-message {\n  background: white;\n  padding: 16px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #667eea;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .legal-assistant {\n    border-left: none;\n  }\n\n  .message {\n    max-width: 95%;\n  }\n\n  .chat-input-form {\n    gap: 4px;\n  }\n\n  .chat-input {\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n}\n\n/* Download section styles */\n.download-section {\n  margin-top: 12px;\n  padding: 12px;\n  background: linear-gradient(135deg, #f8f9ff 0%, #e8f4fd 100%);\n  border-radius: 12px;\n  border: 1px solid #e1e8ff;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.download-btn {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n  text-decoration: none;\n  justify-content: center;\n}\n\n.download-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);\n  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n}\n\n.download-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);\n}\n\n.download-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n}\n\n/* ================= Professional Assistant Formatting ================= */\n.assistant-formatted {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen;\n  font-size: 15px;\n  line-height: 1.55;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  white-space: normal;\n}\n\n.assistant-formatted .assistant-heading {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: #374151;\n  background: linear-gradient(90deg, #eef2ff 0%, #f0fdfa 100%);\n  padding: 4px 8px;\n  border-radius: 6px;\n  margin-right: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.assistant-list {\n  margin: 2px 0 6px 0;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.assistant-list.ordered {\n  list-style: decimal;\n}\n.assistant-list {\n  list-style: disc;\n}\n.assistant-list li {\n  padding-left: 4px;\n  line-height: 1.5;\n}\n\n.assistant-paragraph {\n  margin: 0;\n  position: relative;\n}\n\n.assistant-spacer {\n  height: 8px;\n}\n\n.assistant-link {\n  color: #2563eb;\n  text-decoration: none;\n  font-weight: 500;\n}\n.assistant-link:hover {\n  text-decoration: underline;\n}\n\n.inline-code {\n  background: #f3f4f6;\n  padding: 2px 5px;\n  border-radius: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n    \"Liberation Mono\", monospace;\n  font-size: 13px;\n  border: 1px solid #e5e7eb;\n}\n\n.kv-pair strong {\n  color: #111827;\n}\n.kv-pair {\n  display: inline-block;\n  margin-right: 10px;\n}\n\n/* Risk / status tags */\n.risk-tag::before {\n  content: attr(data-label);\n}\n.risk-tag.critical {\n  background: linear-gradient(90deg, #fee2e2, #fecaca);\n  border-left: 4px solid #dc2626;\n  padding: 6px 10px;\n  border-radius: 6px;\n}\n.risk-tag.warning {\n  background: linear-gradient(90deg, #fef9c3, #fde68a);\n  border-left: 4px solid #d97706;\n  padding: 6px 10px;\n  border-radius: 6px;\n}\n.risk-tag.success {\n  background: linear-gradient(90deg, #dcfce7, #bbf7d0);\n  border-left: 4px solid #059669;\n  padding: 6px 10px;\n  border-radius: 6px;\n}\n\n.risk-tag.critical strong {\n  color: #991b1b;\n}\n.risk-tag.warning strong {\n  color: #92400e;\n}\n.risk-tag.success strong {\n  color: #065f46;\n}\n\n/* Improve spacing after formatted block inside message bubble */\n.message.assistant .assistant-formatted {\n  width: 100%;\n}\n\n/* Markdown style headings inside assistant messages */\n.assistant-formatted .assistant-md-heading {\n  font-weight: 600;\n  line-height: 1.3;\n  margin: 10px 0 4px 0;\n  color: #111827;\n  position: relative;\n}\n.assistant-formatted .assistant-md-heading.h1 {\n  font-size: 18px;\n  padding-top: 4px;\n}\n.assistant-formatted .assistant-md-heading.h2 {\n  font-size: 16px;\n}\n.assistant-formatted .assistant-md-heading.h3 {\n  font-size: 15px;\n}\n.assistant-formatted .assistant-md-heading:not(:first-child)::before {\n  content: \"\";\n  position: absolute;\n  top: -6px;\n  left: 0;\n  height: 1px;\n  width: 60%;\n  background: linear-gradient(90deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0));\n}\n\n/* Section wrapper */\n.assistant-section {\n  margin: 8px 0 10px 0;\n}\n.assistant-heading-line {\n  margin-bottom: 6px;\n}\n\n/* Pill list styling (risk signals, requirements) */\n.pill-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.pill {\n  font-size: 12px;\n  line-height: 1.2;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  color: #374151;\n  font-weight: 500;\n  letter-spacing: 0.25px;\n  max-width: 320px;\n  white-space: normal;\n}\n.pill.info {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n}\n.pill.warning {\n  background: #fef9c3;\n  border-color: #fcd34d;\n  color: #92400e;\n}\n.pill.critical {\n  background: #fee2e2;\n  border-color: #fca5a5;\n  color: #991b1b;\n}\n\n/* Improve paragraph spacing after pills */\n.assistant-section + .assistant-paragraph {\n  margin-top: 6px;\n}\n\n/* Clear Chat Confirmation Dialog */\n.assistant-body {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin: 0;\n  padding: 0;\n  height: calc(100vh - 65px);\n  overflow: hidden;\n}\n\n.confirmation-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.14);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  backdrop-filter: blur(4px);\n  border-radius: 0 0 16px 16px;\n  margin-top: 0;\n}\n\n.confirmation-dialog {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  max-width: 400px;\n  width: 90%;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.confirmation-content {\n  padding: 24px;\n}\n\n.confirmation-content h3 {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  text-align: center;\n}\n\n.confirmation-content p {\n  margin: 0 0 20px 0;\n  color: #666;\n  line-height: 1.5;\n  text-align: center;\n}\n\n.confirmation-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.confirm-btn,\n.cancel-btn {\n  padding: 0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  width: 120px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  flex-grow: 0;\n  min-width: 120px;\n  max-width: 120px;\n}\n\n.confirm-btn {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n}\n\n.confirm-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);\n  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);\n}\n\n.cancel-btn {\n  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);\n}\n\n.cancel-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.4);\n  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);\n}\n\n/* Responsive confirmation dialog */\n@media (max-width: 480px) {\n  .confirmation-dialog {\n    width: 95%;\n    margin: 20px;\n  }\n\n  .confirmation-content {\n    padding: 20px;\n  }\n\n  .confirmation-buttons {\n    flex-direction: column;\n  }\n\n  .confirm-btn,\n  .cancel-btn {\n    width: 100%;\n    min-width: unset;\n    max-width: unset;\n  }\n}\n\n.legal-assistant {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: transparent;\n  border-left: none;\n  position: relative;\n  box-shadow: none;\n  min-width: 250px;\n  max-width: 800px;\n}\n\n.resizer-handle {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  cursor: ew-resize;\n  background: transparent;\n}\n.resizer-handle:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n/* ================= Enhanced AI Research Mode Button ================= */\n/* Extends base .research-mode-btn styling without breaking existing layout */\n.research-mode-btn.ai-mode-btn {\n  position: relative;\n  overflow: hidden;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  font-size: 13px;\n  border: 2px solid rgba(0, 0, 0, 0.08); /* Neutral border when inactive */\n  background: radial-gradient(\n    circle at 30% 30%,\n    rgba(255, 255, 255, 0.55) 0%,\n    rgba(240, 242, 255, 0.5) 55%,\n    rgba(230, 235, 255, 0.55) 100%\n  );\n  color: #374151;\n  transition: transform 0.3s ease, border-color 0.3s ease;\n  backdrop-filter: blur(14px);\n  isolation: isolate;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.research-mode-btn.ai-mode-btn .ai-text {\n  color: #4f46e5; /* Plain indigo text when inactive */\n  text-shadow: none;\n  position: relative;\n  z-index: 2;\n  letter-spacing: 0.5px;\n}\n\n.research-mode-btn.ai-mode-btn .ai-sparkles {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n/* Sparkle pseudo elements */\n.research-mode-btn.ai-mode-btn .ai-sparkles::before,\n.research-mode-btn.ai-mode-btn .ai-sparkles::after {\n  content: \"✦\";\n  position: absolute;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.9);\n  text-shadow: 0 0 6px rgba(255, 255, 255, 0.8),\n    0 0 14px rgba(99, 102, 241, 0.9);\n  opacity: 0;\n  transform: scale(0.4) translateY(4px);\n  animation: aiSparkle 3.2s linear infinite;\n  pointer-events: none;\n}\n\n.research-mode-btn.ai-mode-btn .ai-sparkles::before {\n  top: 6px;\n  left: 6px;\n  animation-delay: 0.4s;\n}\n\n.research-mode-btn.ai-mode-btn .ai-sparkles::after {\n  bottom: 6px;\n  right: 8px;\n  animation-delay: 1.2s;\n  font-size: 8px;\n}\n\n/* Hover motion & glow */\n.research-mode-btn.ai-mode-btn:hover {\n  transform: translateY(-2px);\n  border-color: #4f46e5;\n}\n\n.research-mode-btn.ai-mode-btn:hover .ai-text {\n  text-shadow: 0 0 6px rgba(125, 211, 252, 0.9),\n    0 0 16px rgba(147, 51, 234, 0.55);\n}\n\n.research-mode-btn.ai-mode-btn.active {\n  border-color: #4f46e5; /* Only border indicates active */\n  box-shadow: none; /* Remove glow per request */\n}\n\n.research-mode-btn.ai-mode-btn.active .ai-text {\n  color: #4f46e5;\n  background: none;\n  text-shadow: none;\n}\n\n.research-mode-btn.ai-mode-btn.active .ai-text {\n  background: linear-gradient(90deg, #f0f9ff, #e0e7ff, #ddd6fe);\n  -webkit-background-clip: text;\n  background-clip: text;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.85),\n    0 0 22px rgba(96, 165, 250, 0.8);\n}\n\n.research-mode-btn.ai-mode-btn.active .ai-sparkles::before,\n.research-mode-btn.ai-mode-btn.active .ai-sparkles::after {\n  opacity: 1;\n}\n\n/* Focus accessibility */\n.research-mode-btn.ai-mode-btn:focus-visible {\n  outline: 2px solid #6366f1;\n  outline-offset: 3px;\n}\n\n/* Keyframes for sparkle animation */\n@keyframes aiSparkle {\n  0%,\n  65% {\n    opacity: 0;\n    transform: scale(0.3) translateY(4px) rotate(0deg);\n    filter: blur(1px);\n  }\n  70% {\n    opacity: 1;\n    transform: scale(1) translateY(0) rotate(20deg);\n    filter: blur(0);\n  }\n  78% {\n    opacity: 0.9;\n    transform: scale(0.85) translateY(-2px) rotate(45deg);\n  }\n  90% {\n    opacity: 0;\n    transform: scale(0.2) translateY(-6px) rotate(70deg);\n    filter: blur(2px);\n  }\n  100% {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
